"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITerminalStatus = exports.ITerminalTimezone = exports.ITerminalCountry = exports.ITerminalAutoclose = exports.ITerminalEnvironment = exports.ITerminalCapability = exports.ITerminalType = void 0;
var ITerminalType;
(function (ITerminalType) {
    ITerminalType["___LLC_125158LLC"] = "125158LLC";
    ITerminalType["DELTA_3DELTA"] = "3Delta";
    ITerminalType["DELTA_PWS_3DELTAPWS"] = "3DeltaPws";
    ITerminalType["_SOFTWARE_CREDITLINE_911SOFTWARECREDITLINE"] = "911SoftwareCreditline";
    ITerminalType["_ABCLIQUORS"] = "abcLiquors";
    ITerminalType["_ABC610SE"] = "abc610SE";
    ITerminalType["_ACHDIRECT"] = "achDirect";
    ITerminalType["_ACIRCSSWITCH"] = "aciRcsSwitch";
    ITerminalType["_ACOSOFTWARE"] = "acoSoftware";
    ITerminalType["_ACTIVANTFALCON"] = "activantFalcon";
    ITerminalType["_ADSGILBARCO"] = "adsGilbarco";
    ITerminalType["_ADYEN"] = "adyen";
    ITerminalType["_AHCC"] = "ahcc";
    ITerminalType["_AJB"] = "ajb";
    ITerminalType["_AJBFIPAYDIRECTTANDEM"] = "ajbFipayDirectTandem";
    ITerminalType["_AJBICIP610"] = "ajbIcip610";
    ITerminalType["_AJBRTSIBM"] = "ajbRtsIbm";
    ITerminalType["_AJBRTSTANDEM"] = "ajbRtsTandem";
    ITerminalType["_AJBBEVN"] = "ajbBevn";
    ITerminalType["_AJBRUE21"] = "ajbRue21";
    ITerminalType["_AJBSPOCH"] = "ajbSpoch";
    ITerminalType["_ALLUREGLOBAL"] = "allureGlobal";
    ITerminalType["_ALOHAENHANCED610"] = "alohaEnhanced610";
    ITerminalType["_ALOHATERM"] = "alohaTerm";
    ITerminalType["_APRIVAGATEWAY"] = "aprivaGateway";
    ITerminalType["_APRIVAIWL255"] = "aprivaIwl255";
    ITerminalType["_APRIVA610"] = "apriva610";
    ITerminalType["_APRIVAPAYATT"] = "aprivapayAtt";
    ITerminalType["_APRIVAPAYMOBILE"] = "aprivapayMobile";
    ITerminalType["_APTOSEPICORRETAIL"] = "aptosEpicorRetail";
    ITerminalType["_ASCOM"] = "ascom";
    ITerminalType["_ASIG"] = "asig";
    ITerminalType["_AURUS"] = "aurus";
    ITerminalType["_AUTHORIZENET"] = "authorizeNet";
    ITerminalType["_AUTOMATEDCASHSYSTEMS"] = "automatedCashSystems";
    ITerminalType["_B2KSYSTEMS"] = "b2kSystems";
    ITerminalType["_BEVNSOFTWARE"] = "bevnSoftware";
    ITerminalType["_BILLABONG"] = "billabong";
    ITerminalType["_BNCB"] = "bncb";
    ITerminalType["_BOBEVANS610"] = "bobEvans610";
    ITerminalType["_BOOKSTOREMANAGER"] = "bookstoreManager";
    ITerminalType["_BOOST2DELTA"] = "boost2Delta";
    ITerminalType["_BOOSTBORAPAYER"] = "boostBoraPayer";
    ITerminalType["_BOOSTDIRECTINSITE"] = "boostDirectInsite";
    ITerminalType["_BOOSTMPG"] = "boostMpg";
    ITerminalType["_BREAKAWAYVISIONPOS"] = "breakawayVisionPos";
    ITerminalType["_BRIDGEPAY"] = "bridgepay";
    ITerminalType["_BRINKSOFTWARE"] = "brinkSoftware";
    ITerminalType["_BUYATAB"] = "buyAtab";
    ITerminalType["_CACLGIFT"] = "caclGift";
    ITerminalType["_CARDINALHEALTH610"] = "cardinalHealth610";
    ITerminalType["_CAYAN"] = "cayan";
    ITerminalType["_CCCIWEBSITE"] = "ccciWebsite";
    ITerminalType["_CDSGLOBALPAYDQ"] = "cdsGlobalPaydq";
    ITerminalType["_CENPOSHOSTCAPTURE"] = "cenposHostCapture";
    ITerminalType["_CENPOSISOEMD"] = "cenposIsoEmd";
    ITerminalType["_CFRE610"] = "cfre610";
    ITerminalType["_CHARGEPAYMENTS"] = "chargePayments";
    ITerminalType["_CHARGESMARTPAYWARECONNECT"] = "chargesmartPaywareConnect";
    ITerminalType["_CHRB610"] = "chrb610";
    ITerminalType["_CHSP"] = "chsp";
    ITerminalType["_CKFRINTRIXSUPERCHARGE"] = "ckfrIntrixSupercharge";
    ITerminalType["_CLRE610SALEPOINT"] = "clre610Salepoint";
    ITerminalType["_COMDATASMARTDESQ"] = "comdataSmartdesq";
    ITerminalType["_COMMERCIANT"] = "commerciant";
    ITerminalType["_CRACKERBARREL"] = "crackerBarrel";
    ITerminalType["_CRAINATLANTA"] = "crainAtlanta";
    ITerminalType["_CRANEVENDINGSERVICES"] = "craneVendingServices";
    ITerminalType["_CREDITCALL"] = "creditCall";
    ITerminalType["_CTRSYSTEMS"] = "ctrSystems";
    ITerminalType["_CUBICPAYMENTAPPLICATION"] = "cubicPaymentApplication";
    ITerminalType["_CYBERSOURCE"] = "cyberSource";
    ITerminalType["_CYBERSOURCEVSNTCONVERSION"] = "cyberSourceVsntConversion";
    ITerminalType["_CYBERSOURCEVSNTRESELLERBASIC"] = "cyberSourceVsntResellerBasic";
    ITerminalType["_CYBERSOURCEVSNTRESELLERPREMIER"] = "cyberSourceVsntResellerPremier";
    ITerminalType["_DATABUSNESSSYSTEMS"] = "dataBusnessSystems";
    ITerminalType["_DATACAP"] = "dataCap";
    ITerminalType["_DATACAPDIALTRAN"] = "dataCapDialTran";
    ITerminalType["_DATACAPEPAYREPRO"] = "dataCapEpayRepro";
    ITerminalType["_DATACAPGIFTEPAY"] = "dataCapGiftEpay";
    ITerminalType["_DATACAPIPTRAN"] = "dataCapIpTran";
    ITerminalType["_DATACAPIPTRANLT"] = "dataCapIpTranLt";
    ITerminalType["_DATACAPIPTRANLTMOBLE"] = "dataCapIpTranLtMoble";
    ITerminalType["_DATACAPNETEPAY"] = "dataCapNetEpay";
    ITerminalType["_DATACAPTRANREPRO"] = "dataCapTranRepro";
    ITerminalType["_DATACAPTWINTRAN"] = "dataCapTwinTran";
    ITerminalType["_DATACAPTWINTXNSERVER"] = "dataCapTwinTxnServer";
    ITerminalType["_DATAVANTAGE"] = "dataVantage";
    ITerminalType["_DATAVANTAGEFNLN610"] = "dataVantageFnln610";
    ITerminalType["_DBSTPLUSENHANCED"] = "dbsTplusEnHanced";
    ITerminalType["_DBSTRANSACTIONPLUS"] = "dbsTransactionPlus";
    ITerminalType["_DEALBIRD"] = "dealBird";
    ITerminalType["_DEJAVOO"] = "dejavoo";
    ITerminalType["_DELEGO"] = "delego";
    ITerminalType["_DIGICOM"] = "digicom";
    ITerminalType["_DIRECTINSITE"] = "directInsite";
    ITerminalType["_DISCGOTECH"] = "discGoTech";
    ITerminalType["_DL610SNT"] = "dl610Snt";
    ITerminalType["_DLGLVARSOFTWARE"] = "dlglVarSoftware";
    ITerminalType["_DLGL610S"] = "dlgl610s";
    ITerminalType["_DOMINOSACI"] = "dominosAci";
    ITerminalType["_ECOMMERCEPLUS"] = "ecommercePlus";
    ITerminalType["_EDGIL"] = "edgil";
    ITerminalType["_EESCOMPANIES"] = "eesCompanies";
    ITerminalType["_ELAVONENCONCERT610"] = "elavonEnConcert610";
    ITerminalType["_ELAVONFUSEBOXGATEWAY"] = "elavonFuseboxGateway";
    ITerminalType["_ELAVONPROTOBASE"] = "elavonProtobase";
    ITerminalType["_ELAVONPAYMENTS"] = "elavonPayments";
    ITerminalType["_ELPL610R"] = "elpl610r";
    ITerminalType["_EPAYHEALTHCAREMONETRA"] = "epayHealthcareMonetra";
    ITerminalType["_EQUINOX"] = "equinox";
    ITerminalType["_ESDCARD"] = "esdCard";
    ITerminalType["_EATOUCH"] = "eatouch";
    ITerminalType["_EXATOUCHVSB"] = "exatouchVsb";
    ITerminalType["_EXIT41"] = "exit41";
    ITerminalType["_EZDINE"] = "ezDine";
    ITerminalType["_EZRETAIL"] = "ezRetail";
    ITerminalType["_FANDANGO"] = "fandango";
    ITerminalType["_FIRSTGLOBALBILLINGSAPWALLETVSB"] = "firstGlobalBillingSapwalletVsb";
    ITerminalType["_FITB610S"] = "fitb610s";
    ITerminalType["_FREDMEYR610"] = "fredmeyr610";
    ITerminalType["_FREEDOMPAY"] = "freedomPay";
    ITerminalType["_FTNIGATEWAYETRAN"] = "ftniGatewayEtran";
    ITerminalType["_FUTUREPOSVSB"] = "futurePosVsb";
    ITerminalType["GAMBLEID_TSEVO_GAMBLEIDTSEVO"] = "GambleidTsevo";
    ITerminalType["GIFTANGO_GIFTANGO"] = "Giftango";
    ITerminalType["GIVEX_GIVEX"] = "Givex";
    ITerminalType["_GMSPAYMENTGATEWAY"] = "gmsPaymentGateway";
    ITerminalType["_GMSPAJB"] = "gmsPajb";
    ITerminalType["_GNCTSOFTWARE"] = "gnctSoftware";
    ITerminalType["_GOEMERCHANT"] = "goEMerchant";
    ITerminalType["_GOVOLUTION"] = "govolution";
    ITerminalType["_GRANTSTREET"] = "grantStreet";
    ITerminalType["_GREATLAKESSCRIP"] = "greatLakesScrip";
    ITerminalType["_GREATLAKESSCRIPVAR"] = "greatLakesScripVar";
    ITerminalType["_GSICOMMERCE"] = "gsiCommerce";
    ITerminalType["_HANDPOINT"] = "handpoint";
    ITerminalType["_HARLEYOWNERSGROUP"] = "harleyOwnersGroup";
    ITerminalType["_HIGHRADIUS"] = "highradius";
    ITerminalType["_HP"] = "hp";
    ITerminalType["_HYPERCOM5500M"] = "hypercom5500m";
    ITerminalType["_HYPERCOMPAYMENTSERVER"] = "hypercomPaymentServer";
    ITerminalType["_HYPERCOMT4205"] = "hypercomT4205";
    ITerminalType["_HYPERCOMT4205E2E"] = "hypercomT4205E2e";
    ITerminalType["_HYPERCOMT4210"] = "hypercomT4210";
    ITerminalType["_HYPERCOMT4210E2E"] = "hypercomT4210E2e";
    ITerminalType["_HYPERCOM4220DIAL"] = "hypercom4220Dial";
    ITerminalType["_HYPERCOM4220DIALE2E"] = "hypercom4220DialE2e";
    ITerminalType["_HYPERCOM4220SSL"] = "hypercom4220Ssl";
    ITerminalType["_HYPERCOM4220SSLE2E"] = "hypercom4220SslE2e";
    ITerminalType["_I2CVSB"] = "i2cVsb";
    ITerminalType["_IBMACE"] = "ibmace";
    ITerminalType["_ICVERIFY"] = "icVerify";
    ITerminalType["_INCENTPAY"] = "incentPay";
    ITerminalType["_INDEX"] = "index";
    ITerminalType["_INGENICO610"] = "ingenico610";
    ITerminalType["_INGENICO720"] = "ingenico720";
    ITerminalType["_INGENICOICT2203XDIAL"] = "ingenicoIct2203xDial";
    ITerminalType["_INGENICOICT2203XDIALE2EE"] = "ingenicoIct2203xDialE2ee";
    ITerminalType["_INGENICOICT2203XDIALPILOT"] = "ingenicoIct2203xDialPilot";
    ITerminalType["_INGENICOICT2203XSSL"] = "ingenicoIct2203xSsl";
    ITerminalType["_INGENICOICT2203XSSLE2EE"] = "ingenicoIct2203xSslE2ee";
    ITerminalType["_INGENICOICT2203XSSLPILOT"] = "ingenicoIct2203xSSLPilot";
    ITerminalType["_INGENICOICT220CTLS3XDIAL"] = "ingenicoIct220Ctls3xDial";
    ITerminalType["_INGENICOICT220CTLS3XDIALEE2E"] = "ingenicoIct220Ctls3xDialEe2e";
    ITerminalType["_INGENICOICT220CTLS3XSSL"] = "ingenicoIct220Ctls3xSsl";
    ITerminalType["_INGENICOICT220CTLS3XSSLE2EE"] = "ingenicoIct220Ctls3xSslE2ee";
    ITerminalType["_INGENICOICT2503XDIAL"] = "ingenicoIct2503xDial";
    ITerminalType["_INGENICOICT2503XDIALE2EE"] = "ingenicoIct2503xDialE2ee";
    ITerminalType["_INGENICOICT2503XSSL"] = "ingenicoIct2503xSsl";
    ITerminalType["_INGENICOICT2503XSSLE2EE"] = "ingenicoIct2503xSSLE2ee";
    ITerminalType["_INGENICOIWL222BTDIAL"] = "ingenicoIwl222BtDial";
    ITerminalType["_INGENICOIWL222BTDIALE2EE"] = "ingenicoIwl222BtDialE2ee";
    ITerminalType["_INGENICOIWL222BTSSL"] = "ingenicoIwl222BtSsl";
    ITerminalType["_INGENICOIWL222BTSSLE2EE"] = "ingenicoIwl222BtSSlE2ee";
    ITerminalType["_INGENICOIWL252BTDIAL"] = "ingenicoIwl252BtDial";
    ITerminalType["_INGENICOIW252BTDIALE2EE"] = "ingenicoIw252BtDialE2ee";
    ITerminalType["_INGENICOIW252BTSSL"] = "ingenicoIw252BtSsl";
    ITerminalType["_INGENICOIW252BTSSLE2EE"] = "ingenicoIw252BtSslE2ee";
    ITerminalType["_INGENICOIW2553G"] = "ingenicoIw2553g";
    ITerminalType["_INGENICOIW2553GE2EE"] = "ingenicoIw2553gE2ee";
    ITerminalType["_INGENICOSIENTERPRISE"] = "ingenicoSiEnterprise";
    ITerminalType["_INSTAMED"] = "instamed";
    ITerminalType["_IPAYGATEWAY"] = "ipayGateway";
    ITerminalType["_ISD"] = "isd";
    ITerminalType["_ISLANDPACIFIC"] = "islandPacific";
    ITerminalType["_ISVOPENMOTIONVSB"] = "isvOpenmotionVsb";
    ITerminalType["_ISV510"] = "isv510";
    ITerminalType["_ISV600"] = "isv600";
    ITerminalType["_ISV610"] = "isv610";
    ITerminalType["_ISVVSK"] = "isvVsk";
    ITerminalType["_ITRANSACT"] = "itransact";
    ITerminalType["_JEWLSOFTWARE"] = "jewlSoftware";
    ITerminalType["_JOCKEYECOMM"] = "jockeyEcomm";
    ITerminalType["_JOCKEYRETAIL"] = "jockeyRetail";
    ITerminalType["_KACHYNG"] = "kachyng";
    ITerminalType["_KLIK"] = "klik";
    ITerminalType["_KMARTGIFT"] = "kmartGift";
    ITerminalType["_KUBRA"] = "kubra";
    ITerminalType["_LIGHTYEAR"] = "lightYear";
    ITerminalType["_LINKED2PAY"] = "linked2Pay";
    ITerminalType["_LONGRANGESYSTEMSLRS"] = "longRangeSystemsLrs";
    ITerminalType["_LUMBERVISAK"] = "lumberVisaK";
    ITerminalType["_LUMGPOS"] = "lumgPos";
    ITerminalType["_MAGICWRIGHTER"] = "magicWrighter";
    ITerminalType["_MAGNETCARDSERVICES"] = "magnetCardServices";
    ITerminalType["_MAINSTREETMONETRA510"] = "mainstreetMonetra510";
    ITerminalType["_MAINSTREETMONETRA610"] = "mainstreetMonetra610";
    ITerminalType["_MASTERCARDOPENAPI"] = "mastercardOpenapi";
    ITerminalType["_MASTERCARDPAYMENTGATEWAY"] = "mastercardPaymentGateway";
    ITerminalType["_MEIAPRIVA"] = "meiApriva";
    ITerminalType["_MENUSOFTDIGITALDINING"] = "menusoftDigitalDining";
    ITerminalType["_MERCHANTLINKCDG"] = "merchantLinkCDG";
    ITerminalType["_MERCHANTLINKCREDIT"] = "merchantLinkCredit";
    ITerminalType["_MERITSOLAR"] = "meritSolar";
    ITerminalType["_MICROSSYMPHONY"] = "microsSymphony";
    ITerminalType["_MICROSALEPOS"] = "microsalePos";
    ITerminalType["_MIDNITEEXPRESSSLIPSTREAM"] = "midniteExpressSlipstream";
    ITerminalType["_MIGHTYTICKET"] = "mightyTicket";
    ITerminalType["_MILLENIUMRETAILSOLUTIONS"] = "milleniumRetailSolutions";
    ITerminalType["_MOBILEACCEPT"] = "mobileAccept";
    ITerminalType["_MOBILEACCEPTFLATRATE"] = "mobileAcceptFlatRate";
    ITerminalType["_MOBILECHECKOUTQMS"] = "mobileCheckoutQms";
    ITerminalType["_MOBILECHECKOUTSTANDARD"] = "mobileCheckoutStandard";
    ITerminalType["_MONETRAAUTH"] = "monetraAuth";
    ITerminalType["_MONROMUFFLER"] = "monroMuffler";
    ITerminalType["_MPAYGATEWAY"] = "mpayGateway";
    ITerminalType["_MTXEPSWINEPS"] = "mtxepsWineps";
    ITerminalType["_MVSP"] = "mvsp";
    ITerminalType["_NCRADVANCEDRESTAURANT"] = "ncrAdvancedRestaurant";
    ITerminalType["_NCRCINEMA"] = "ncrCinema";
    ITerminalType["_NCRCOUNTERPOINT510"] = "ncrCounterpoint510";
    ITerminalType["_NCRCOUNTERPOINT610"] = "ncrCounterpoint610";
    ITerminalType["_NCRRETALIXCONNECTEDPAYMENTS"] = "ncrRetalixConnectedPayments";
    ITerminalType["_NCRSILVER"] = "ncrSilver";
    ITerminalType["_NCRSILVERPRO"] = "ncrSilverPro";
    ITerminalType["_NCRSILVERPROQMS"] = "ncrSilverProQms";
    ITerminalType["_NEOGAMES610"] = "neoGames610";
    ITerminalType["_NETWORKMERCHANTS"] = "networkMerchants";
    ITerminalType["_NSBEPS"] = "nsbEps";
    ITerminalType["_NOURDERSODP"] = "nourdersOdp";
    ITerminalType["_NURIT2159"] = "nurit2159";
    ITerminalType["_NURIT8400EDIAL"] = "nurit8400EDial";
    ITerminalType["_OCHARLEYS"] = "oCharleys";
    ITerminalType["_OLO"] = "olo";
    ITerminalType["_OPCONNECT"] = "opConnect";
    ITerminalType["_OPTIMALPAYMENTSGATEWAY"] = "optimalPaymentsGateway";
    ITerminalType["_ORCCCOLLECTPAY"] = "orccCollectPay";
    ITerminalType["_ORCCACIWORLDWIDE"] = "orccAciWorldwide";
    ITerminalType["_ORDERTALK"] = "orderTalk";
    ITerminalType["_PAVITALCHECK"] = "paVitalcheck";
    ITerminalType["_PAFIDELITYEXPRESS"] = "paFidelityExpress";
    ITerminalType["_PAGRANTSTREET"] = "paGrantStreet";
    ITerminalType["_PARKMOBILE"] = "parkmobile";
    ITerminalType["_PAXSP30CASIO"] = "paxSp30Casio";
    ITerminalType["_PAYGOV"] = "payGov";
    ITerminalType["_PAYDIANTSJ"] = "paydiantSj";
    ITerminalType["_PAYFIRSTEDCVPOS"] = "payFirstEdcVpos";
    ITerminalType["_PAYPALPAYFLOWLINK"] = "paypalPayflowLink";
    ITerminalType["_PAYPALPAYFLOWLINKRESELLER"] = "paypalPayflowLinkReseller";
    ITerminalType["_PAYPALPAYFLOWPRO"] = "paypalPayflowPro";
    ITerminalType["_PAYPALPAYFLOWPRORESELLER"] = "paypalPayflowProReseller";
    ITerminalType["_PAYRIGHT"] = "payright";
    ITerminalType["_PAYTECHVSB"] = "paytechVsb";
    ITerminalType["_PCAMERICA"] = "pcAmerica";
    ITerminalType["PLSTQ_PLSTQ610"] = "PLSTQ610";
    ITerminalType["_PLUGNPLAY"] = "plugNPlay";
    ITerminalType["_POYNT"] = "poynt";
    ITerminalType["_PRECIDA"] = "precida";
    ITerminalType["_PRICETONCARDCONNECT"] = "pricetonCardConnect";
    ITerminalType["_PRINCETONECOMMCOLLECTPAY"] = "princetonEcommCollectpay";
    ITerminalType["_PRINCETONPAYMENTS"] = "princetonPayments";
    ITerminalType["_PRINCETONPAYWARE"] = "princetonPayware";
    ITerminalType["_PROPSOFTWARE"] = "propSoftware";
    ITerminalType["_PURECOMMERCEVSB"] = "purecommerceVsb";
    ITerminalType["_PXPSOLUTIONSRETAIL"] = "pxpSolutionsRetail";
    ITerminalType["_REDIANTRPOSLIGHTHOUSE"] = "rediantRposLighthouse";
    ITerminalType["_RAINBOWAPPAREL"] = "rainbowApparel";
    ITerminalType["_RDYC610S"] = "rdyc610s";
    ITerminalType["_REDOAKPS"] = "redOakPs";
    ITerminalType["_REDFINNETWORK"] = "redfinNetwork";
    ITerminalType["_REMCOSOFTWARE"] = "remcoSoftware";
    ITerminalType["_RENTACENTER"] = "rentACenter";
    ITerminalType["_REPROONLYINGICT220DIAL"] = "reproOnlyIngIct220Dial";
    ITerminalType["_REPROONLYINGICT220DIALE2EE"] = "reproOnlyIngIct220DialE2ee";
    ITerminalType["_REPROONLYINGICT220SSLE2EE"] = "reproOnlyIngIct220SslE2ee";
    ITerminalType["_REPROONLYINGICT250DIAL"] = "reproOnlyIngIct250Dial";
    ITerminalType["_REPROONLYINGICT250DIALE2EE"] = "reproOnlyIngIct250DialE2ee";
    ITerminalType["_REPROONLYINGICT250SSL"] = "reproOnlyIngIct250Ssl";
    ITerminalType["_REPROONLYINGICT250SSLE2EE"] = "reproOnlyIngIct250SslE2ee";
    ITerminalType["_REPROONLYVERIFONEVX520DCDIAL"] = "reproOnlyVerifoneVx520DcDial";
    ITerminalType["_REPROONLYVERIFONEVX520DCSSL"] = "reproOnlyVerifoneVx520DcSsl";
    ITerminalType["_REPROONLYVERIFONEVX520DIALCTLS"] = "reproOnlyVerifoneVx520DialCtls";
    ITerminalType["_REPROONLYVERIFONEVX520SSLCTLS"] = "reproOnlyVerifoneVx520SslCtls";
    ITerminalType["_RETRIEVERSOFTWARE"] = "retrieverSoftware";
    ITerminalType["_REVLINKCOLLECT"] = "revlinkCollect";
    ITerminalType["_REVTRAK"] = "revtrak";
    ITerminalType["_REAMMOBILE"] = "reamMobile";
    ITerminalType["_ROAMMOBILETEST"] = "roamMobileTest";
    ITerminalType["_ROAMDATA"] = "roamData";
    ITerminalType["_SALEPOINT"] = "salepoint";
    ITerminalType["_SALEPOINTCLAIRES"] = "salepointClaires";
    ITerminalType["_SBCSOLUTIONS"] = "sbcSolutions";
    ITerminalType["_SECURETRADING"] = "secureTrading";
    ITerminalType["_SEQUOIARETIALSYSTEMS"] = "sequoiaRetialSystems";
    ITerminalType["_SHCI610"] = "shci610";
    ITerminalType["_SHIFT4ONTHENET"] = "shift4OnTheNet";
    ITerminalType["_SIGHTLINEPAYMENTS"] = "sightlinePayments";
    ITerminalType["_SLIMCDENTNONRESELLER"] = "slimCdEntNonReseller";
    ITerminalType["_SLIMCDENTERPRISE"] = "slimCdEnterprise";
    ITerminalType["_SLIMCDPRO"] = "slimCdPro";
    ITerminalType["_SLIMCDPRONONRESELLER"] = "slimCdProNonReseller";
    ITerminalType["_SNLH610"] = "snlh610";
    ITerminalType["_SOUTHERNDATACOMM"] = "southernDataComm";
    ITerminalType["_SPSEZPAY"] = "spsEzpay";
    ITerminalType["_SQUIRRELSYSTEMS"] = "squirrelSystems";
    ITerminalType["_STER610"] = "ster610";
    ITerminalType["_STORISVISION9"] = "storisVision9";
    ITerminalType["_STSTSOFTWARE"] = "ststSoftware";
    ITerminalType["_TALBOTS"] = "talbots";
    ITerminalType["_TANGIBLEPAYMENTS"] = "tangiblePayments";
    ITerminalType["_TENDERRETAIL"] = "tenderRetail";
    ITerminalType["_TILLSTER"] = "tillster";
    ITerminalType["_TNSPAYGATEWAY"] = "tnspayGateway";
    ITerminalType["_TOAST"] = "toast";
    ITerminalType["_TOYZPOS"] = "toyzPos";
    ITerminalType["_TRANSACTIONWIRELESSSVS"] = "transactionWirelessSvs";
    ITerminalType["_TRANSAX"] = "transax";
    ITerminalType["_TRANZGATE"] = "tranzgate";
    ITerminalType["_TREM610"] = "trem610";
    ITerminalType["_TRIVERSITY"] = "triversity";
    ITerminalType["_TRIVERSITYPOS"] = "triversityPos";
    ITerminalType["_TRUSTCOMMVAULT610"] = "trustcommVault610";
    ITerminalType["_TRUSTCOMMVAULT600"] = "trustcommVault600";
    ITerminalType["_TRUSTCOMMERCE2011"] = "trustcommerce2011";
    ITerminalType["_TSYSAMEXPIPPCSOFTWARE"] = "tsysAmexPipPcSoftware";
    ITerminalType["_TSYSAMEXPIPTERMINAL"] = "tsysAmexPipTerminal";
    ITerminalType["_TSYSDIALPAY"] = "tsysDialPay";
    ITerminalType["_TSYSPOSPORT"] = "tsysPosPort";
    ITerminalType["_TWITPAY"] = "twitpay";
    ITerminalType["_UHAUL"] = "uhaul";
    ITerminalType["_UICBEZEL8"] = "uicBezel8";
    ITerminalType["_UPSOLUTION610"] = "upSolution610";
    ITerminalType["_USAEPAY"] = "usaEpay";
    ITerminalType["_USFS"] = "usfs";
    ITerminalType["_VENTEK"] = "ventek";
    ITerminalType["_VERIFONE"] = "verifone";
    ITerminalType["_VERIFONE510TERMINAL"] = "verifone510Terminal";
    ITerminalType["_VERIFONE600TERMINAL"] = "verifone600Terminal";
    ITerminalType["_VERIFONE610"] = "verifone610";
    ITerminalType["_VERIFONEOMNI3200"] = "verifoneOmni3200";
    ITerminalType["_VERIFONEPAYWARECONNECT"] = "verifonePaywareConnect";
    ITerminalType["_VERIFONEPAYWAREMOBILE"] = "verifonePaywareMobile";
    ITerminalType["_VERIFONEPAYWAREPC"] = "verifonePaywarePc";
    ITerminalType["_VERIFONEPAYWARETRANACTRITA"] = "verifonePaywareTranactRita";
    ITerminalType["_VERIFONEPCCHARGEGOSOFTWARE"] = "verifonePcChargeGoSoftware";
    ITerminalType["_VERIFONEPOINT"] = "verifonePoint";
    ITerminalType["_VERIFONEPOINTENTMX"] = "verifonePointEntMx";
    ITerminalType["_VERIFONEPOINTENTVX"] = "verifonePointEntVx";
    ITerminalType["_VERIFONERUBY"] = "verifoneRuby";
    ITerminalType["_VERIFONEVX510"] = "verifoneVx510";
    ITerminalType["_VERIFONEVX510DCDIAL"] = "verifoneVx510DcDial";
    ITerminalType["_VERIFONEVX510DCIP"] = "verifoneVx510DcIp";
    ITerminalType["_VERIFONEVX510DCSSL"] = "verifoneVx510DcSsl";
    ITerminalType["_VERIFONEVX510LE"] = "verifoneVx510le";
    ITerminalType["_VERIFONEVX520DCDIALCTLSE2EE"] = "verifoneVx520DcDialCtlsE2ee";
    ITerminalType["_VERIFONEVX520DCDIALE2EE"] = "verifoneVx520DcDialE2ee";
    ITerminalType["_VERIFONEVX520DCIP1"] = "verifoneVx520DcIp1";
    ITerminalType["_VERIFONEVX520DCIP2"] = "verifoneVx520DcIp2";
    ITerminalType["_VERIFONEVX520DCIPCTLS"] = "verifoneVx520DcIpCtls";
    ITerminalType["_VERIFONEVX520DCIPCTLSE2EE"] = "verifoneVx520DcIpCtlsE2ee";
    ITerminalType["_VERIFONEVX520DCSSLCTLSE2EE"] = "verifoneVx520DcSslCtlsE2ee";
    ITerminalType["_VERIFONEVX520DCSSLE2EE"] = "verifoneVx520DcSslE2ee";
    ITerminalType["_VERIFONEVX520DIALONLY"] = "verifoneVx520DialOnly";
    ITerminalType["_VERIFONEVX570DIAL"] = "verifoneVx570Dial";
    ITerminalType["_VERIFONEVX570IP"] = "verifoneVx570Ip";
    ITerminalType["_VERIFONEVX570SSL"] = "verifoneVx570Ssl";
    ITerminalType["_VERIFONEVX6803GGPRS"] = "verifoneVx6803gGprs";
    ITerminalType["_VICOSOFTWARE"] = "vicoSoftware";
    ITerminalType["_VIRTUALTERMINAL"] = "virtualTerminal";
    ITerminalType["_VISTAENTERTAINMENT"] = "vistaEntertainment";
    ITerminalType["_VITALCHECK"] = "vitalcheck";
    ITerminalType["_VMCADDONANDROIDBYODQMD"] = "vmcAddOnAndroidByodQmd";
    ITerminalType["_VMCADDONANDROIDBYODSTANDARD"] = "vmcAddOnAndroidByodStandard";
    ITerminalType["_VMCADDONBUNDLEBYODQMS"] = "vmcAddOnBundleByodQms";
    ITerminalType["_VMCADDONBUNDLEBYODSTANDARD"] = "vmcAddOnBundleByodStandard";
    ITerminalType["_VMCADDONBUNDLECELLULARQMD"] = "vmcAddOnBundleCellularQmd";
    ITerminalType["_VMCADDONBUNDLECELLULARSTANDARD"] = "vmcAddOnBundleCellularStandard";
    ITerminalType["_VMCADDONBUNDLEWIFIQMD"] = "vmcAddOnBundleWifiQmd";
    ITerminalType["_VMCADDONBUNDLEWIFISTANDARD"] = "vmcAddOnBundleWifiStandard";
    ITerminalType["_VMCFIELDBUNDLEBYODQMD"] = "vmcFieldBundleByodQmd";
    ITerminalType["_VMCFIELDBUNDLEBYODSTANDARD"] = "vmcFieldBundleByodStandard";
    ITerminalType["_VMCFIELDBUNDLECELLULARQMS"] = "vmcFieldBundleCellularQms";
    ITerminalType["_VMCFIELDBUNDLECELLULARSTANDARD"] = "vmcFieldBundleCellularStandard";
    ITerminalType["_VMCSTOREANDROIDBYODQMS"] = "vmcStoreAndroidByodQms";
    ITerminalType["_VMCSTOREANDROIDBYODSTANDARD"] = "vmcStoreAndroidByodStandard";
    ITerminalType["_VMCSTOREBUNDLEBYODQMS"] = "vmcStoreBundleByodQms";
    ITerminalType["_VMCSTOREBUNDLEBYODSTANDARD"] = "vmcStoreBundleByodStandard";
    ITerminalType["_VMCSTOREBUNDLECELLULARQMS"] = "vmcStoreBundleCellularQms";
    ITerminalType["_VMCSTOREBUNDLECELLULARSTANDARD"] = "vmcStoreBundleCellularStandard";
    ITerminalType["_VMCSTOREBUNDLEWIFIQMS"] = "vmcStoreBundleWifiQms";
    ITerminalType["_VMCSTOREBUNDLEWIFISTANDARD"] = "vmcStoreBundleWifiStandard";
    ITerminalType["_VPLUS"] = "vPlus";
    ITerminalType["_VSB"] = "vsb";
    ITerminalType["_VSBGREENBEANRECYCLE"] = "vsbGreenbeanRecycle";
    ITerminalType["_VSBKAIZEN"] = "vsbKaizen";
    ITerminalType["_VSBORDERBRIDGE"] = "vsbOrderbridge";
    ITerminalType["_VSBPHONIXMANAGEDNETWORK"] = "vsbPhonixManagedNetwork";
    ITerminalType["_VSBSAMURAI"] = "vsbSamurai";
    ITerminalType["_VSBVISAT"] = "vsbVisat";
    ITerminalType["_VSBWIRETRUST"] = "vsbWiretrust";
    ITerminalType["_VSBXGATEWAY"] = "vsbXgateway";
    ITerminalType["_WANDGIFT"] = "wandGift";
    ITerminalType["_WAYSYSTEMSMTT5000"] = "waySystemsMtt5000";
    ITerminalType["_WENDYSCOM"] = "wendysCom";
    ITerminalType["_WHIRL"] = "whirl";
    ITerminalType["_WINN610S"] = "winn610s";
    ITerminalType["_XPAYSOFTWARE"] = "xpaySoftware";
    ITerminalType["_XPIENT610"] = "xpient610";
    ITerminalType["_XPIENTSOLUTIONS"] = "xpientSolutions";
})(ITerminalType = exports.ITerminalType || (exports.ITerminalType = {}));
var ITerminalCapability;
(function (ITerminalCapability) {
    ITerminalCapability[ITerminalCapability["KEYED_1"] = 1] = "KEYED_1";
    ITerminalCapability[ITerminalCapability["MAGSTRIPE_2"] = 2] = "MAGSTRIPE_2";
    ITerminalCapability[ITerminalCapability["EMV_3"] = 3] = "EMV_3";
    ITerminalCapability[ITerminalCapability["DEFAULT_4"] = 4] = "DEFAULT_4";
})(ITerminalCapability = exports.ITerminalCapability || (exports.ITerminalCapability = {}));
var ITerminalEnvironment;
(function (ITerminalEnvironment) {
    ITerminalEnvironment[ITerminalEnvironment["RETAIL_1"] = 1] = "RETAIL_1";
    ITerminalEnvironment[ITerminalEnvironment["RETAIL_WITH_TIPS_2"] = 2] = "RETAIL_WITH_TIPS_2";
    ITerminalEnvironment[ITerminalEnvironment["RESTAURANT_3"] = 3] = "RESTAURANT_3";
    ITerminalEnvironment[ITerminalEnvironment["LODGING_4"] = 4] = "LODGING_4";
    ITerminalEnvironment[ITerminalEnvironment["BAR_5"] = 5] = "BAR_5";
    ITerminalEnvironment[ITerminalEnvironment["CASH_ADVANCE_6"] = 6] = "CASH_ADVANCE_6";
    ITerminalEnvironment[ITerminalEnvironment["MAILTELEPHONE_ORDER_7"] = 7] = "MAILTELEPHONE_ORDER_7";
    ITerminalEnvironment[ITerminalEnvironment["PAY_AT_THE_PUMP_8"] = 8] = "PAY_AT_THE_PUMP_8";
    ITerminalEnvironment[ITerminalEnvironment["SERVICE_REST_9"] = 9] = "SERVICE_REST_9";
    ITerminalEnvironment[ITerminalEnvironment["ECOMMERCE_10"] = 10] = "ECOMMERCE_10";
    ITerminalEnvironment[ITerminalEnvironment["DIRECT_MARKETING_11"] = 11] = "DIRECT_MARKETING_11";
    ITerminalEnvironment[ITerminalEnvironment["FINE_DINING_12"] = 12] = "FINE_DINING_12";
    ITerminalEnvironment[ITerminalEnvironment["GIFT_CARD_ONLY_13"] = 13] = "GIFT_CARD_ONLY_13";
})(ITerminalEnvironment = exports.ITerminalEnvironment || (exports.ITerminalEnvironment = {}));
var ITerminalAutoclose;
(function (ITerminalAutoclose) {
    ITerminalAutoclose[ITerminalAutoclose["AUTOMATIC_0"] = 0] = "AUTOMATIC_0";
    ITerminalAutoclose[ITerminalAutoclose["MANUAL_1"] = 1] = "MANUAL_1";
    ITerminalAutoclose[ITerminalAutoclose["NONE_2"] = 2] = "NONE_2";
})(ITerminalAutoclose = exports.ITerminalAutoclose || (exports.ITerminalAutoclose = {}));
var ITerminalCountry;
(function (ITerminalCountry) {
    ITerminalCountry["ARUBA_ABW"] = "ABW";
    ITerminalCountry["AFGHANISTAN_AFG"] = "AFG";
    ITerminalCountry["ANGOLA_AGO"] = "AGO";
    ITerminalCountry["ANGUILLA_AIA"] = "AIA";
    ITerminalCountry["ALAND_ISLANDS_ALA"] = "ALA";
    ITerminalCountry["ALBANIA_ALB"] = "ALB";
    ITerminalCountry["ANDORRA_AND"] = "AND";
    ITerminalCountry["UNITED_ARAB_EMIRATES_ARE"] = "ARE";
    ITerminalCountry["ARGENTINA_ARG"] = "ARG";
    ITerminalCountry["ARMENIA_ARM"] = "ARM";
    ITerminalCountry["AMERICAN_SAMOA_ASM"] = "ASM";
    ITerminalCountry["ANTARCTICA_ATA"] = "ATA";
    ITerminalCountry["FRENCH_SOUTHERN_TERRITORIES_ATF"] = "ATF";
    ITerminalCountry["ANTIGUA_AND_BARBUDA_ATG"] = "ATG";
    ITerminalCountry["AUSTRALIA_AUS"] = "AUS";
    ITerminalCountry["AUSTRIA_AUT"] = "AUT";
    ITerminalCountry["AZERBAIJAN_AZE"] = "AZE";
    ITerminalCountry["BURUNDI_BDI"] = "BDI";
    ITerminalCountry["BELGIUM_BEL"] = "BEL";
    ITerminalCountry["BENIN_BEN"] = "BEN";
    ITerminalCountry["BONAIRE_SINT_EUSTATIUS_AND_SABA_BES"] = "BES";
    ITerminalCountry["BURKINA_FASO_BFA"] = "BFA";
    ITerminalCountry["BANGLADESH_BGD"] = "BGD";
    ITerminalCountry["BULGARIA_BGR"] = "BGR";
    ITerminalCountry["BAHRAIN_BHR"] = "BHR";
    ITerminalCountry["BAHAMAS_BHS"] = "BHS";
    ITerminalCountry["BOSNIA_AND_HERZEGOVINA_BIH"] = "BIH";
    ITerminalCountry["SAINT_BARTHLEMY_BLM"] = "BLM";
    ITerminalCountry["BELARUS_BLR"] = "BLR";
    ITerminalCountry["BELIZE_BLZ"] = "BLZ";
    ITerminalCountry["BERMUDA_BMU"] = "BMU";
    ITerminalCountry["BOLIVIA_PLURINATIONAL_STATE_OF_BOL"] = "BOL";
    ITerminalCountry["BRAZIL_BRA"] = "BRA";
    ITerminalCountry["BARBADOS_BRB"] = "BRB";
    ITerminalCountry["BRUNEI_DARUSSALAM_BRN"] = "BRN";
    ITerminalCountry["BHUTAN_BTN"] = "BTN";
    ITerminalCountry["BOUVET_ISLAND_BVT"] = "BVT";
    ITerminalCountry["BOTSWANA_BWA"] = "BWA";
    ITerminalCountry["CENTRAL_AFRICAN_REPUBLIC_CAF"] = "CAF";
    ITerminalCountry["CANADA_CAN"] = "CAN";
    ITerminalCountry["COCOS_KEELING_ISLANDS_CCK"] = "CCK";
    ITerminalCountry["SWITZERLAND_CHE"] = "CHE";
    ITerminalCountry["CHILE_CHL"] = "CHL";
    ITerminalCountry["CHINA_CHN"] = "CHN";
    ITerminalCountry["CTE_DIVOIRE_CIV"] = "CIV";
    ITerminalCountry["CAMEROON_CMR"] = "CMR";
    ITerminalCountry["CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE_COD"] = "COD";
    ITerminalCountry["CONGO_COG"] = "COG";
    ITerminalCountry["COOK_ISLANDS_COK"] = "COK";
    ITerminalCountry["COLOMBIA_COL"] = "COL";
    ITerminalCountry["COMOROS_COM"] = "COM";
    ITerminalCountry["CAPE_VERDE_CPV"] = "CPV";
    ITerminalCountry["COSTA_RICA_CRI"] = "CRI";
    ITerminalCountry["CUBA_CUB"] = "CUB";
    ITerminalCountry["CURAAO_CUW"] = "CUW";
    ITerminalCountry["CHRISTMAS_ISLAND_CXR"] = "CXR";
    ITerminalCountry["CAYMAN_ISLANDS_CYM"] = "CYM";
    ITerminalCountry["CYPRUS_CYP"] = "CYP";
    ITerminalCountry["CZECH_REPUBLIC_CZE"] = "CZE";
    ITerminalCountry["GERMANY_DEU"] = "DEU";
    ITerminalCountry["DJIBOUTI_DJI"] = "DJI";
    ITerminalCountry["DOMINICA_DMA"] = "DMA";
    ITerminalCountry["DENMARK_DNK"] = "DNK";
    ITerminalCountry["DOMINICAN_REPUBLIC_DOM"] = "DOM";
    ITerminalCountry["ALGERIA_DZA"] = "DZA";
    ITerminalCountry["ECUADOR_ECU"] = "ECU";
    ITerminalCountry["EGYPT_EGY"] = "EGY";
    ITerminalCountry["ERITREA_ERI"] = "ERI";
    ITerminalCountry["WESTERN_SAHARA_ESH"] = "ESH";
    ITerminalCountry["SPAIN_ESP"] = "ESP";
    ITerminalCountry["ESTONIA_EST"] = "EST";
    ITerminalCountry["ETHIOPIA_ETH"] = "ETH";
    ITerminalCountry["FINLAND_FIN"] = "FIN";
    ITerminalCountry["FIJI_FJI"] = "FJI";
    ITerminalCountry["FALKLAND_ISLANDS_MALVINAS_FLK"] = "FLK";
    ITerminalCountry["FRANCE_FRA"] = "FRA";
    ITerminalCountry["FAROE_ISLANDS_FRO"] = "FRO";
    ITerminalCountry["MICRONESIA_FEDERATED_STATES_OF_FSM"] = "FSM";
    ITerminalCountry["GABON_GAB"] = "GAB";
    ITerminalCountry["UNITED_KINGDOM_GBR"] = "GBR";
    ITerminalCountry["GEORGIA_GEO"] = "GEO";
    ITerminalCountry["GUERNSEY_GGY"] = "GGY";
    ITerminalCountry["GHANA_GHA"] = "GHA";
    ITerminalCountry["GIBRALTAR_GIB"] = "GIB";
    ITerminalCountry["GUINEA_GIN"] = "GIN";
    ITerminalCountry["GUADELOUPE_GLP"] = "GLP";
    ITerminalCountry["GAMBIA_GMB"] = "GMB";
    ITerminalCountry["GUINEABISSAU_GNB"] = "GNB";
    ITerminalCountry["EQUATORIAL_GUINEA_GNQ"] = "GNQ";
    ITerminalCountry["GREECE_GRC"] = "GRC";
    ITerminalCountry["GRENADA_GRD"] = "GRD";
    ITerminalCountry["GREENLAND_GRL"] = "GRL";
    ITerminalCountry["GUATEMALA_GTM"] = "GTM";
    ITerminalCountry["FRENCH_GUIANA_GUF"] = "GUF";
    ITerminalCountry["GUAM_GUM"] = "GUM";
    ITerminalCountry["GUYANA_GUY"] = "GUY";
    ITerminalCountry["HONG_KONG_HKG"] = "HKG";
    ITerminalCountry["HEARD_ISLAND_AND_MCDONALD_ISLANDS_HMD"] = "HMD";
    ITerminalCountry["HONDURAS_HND"] = "HND";
    ITerminalCountry["CROATIA_HRV"] = "HRV";
    ITerminalCountry["HAITI_HTI"] = "HTI";
    ITerminalCountry["HUNGARY_HUN"] = "HUN";
    ITerminalCountry["INDONESIA_IDN"] = "IDN";
    ITerminalCountry["ISLE_OF_MAN_IMN"] = "IMN";
    ITerminalCountry["INDIA_IND"] = "IND";
    ITerminalCountry["BRITISH_INDIAN_OCEAN_TERRITORY_IOT"] = "IOT";
    ITerminalCountry["IRELAND_IRL"] = "IRL";
    ITerminalCountry["IRAN_ISLAMIC_REPUBLIC_OF_IRN"] = "IRN";
    ITerminalCountry["IRAQ_IRQ"] = "IRQ";
    ITerminalCountry["ICELAND_ISL"] = "ISL";
    ITerminalCountry["ISRAEL_ISR"] = "ISR";
    ITerminalCountry["ITALY_ITA"] = "ITA";
    ITerminalCountry["JAMAICA_JAM"] = "JAM";
    ITerminalCountry["JERSEY_JEY"] = "JEY";
    ITerminalCountry["JORDAN_JOR"] = "JOR";
    ITerminalCountry["JAPAN_JPN"] = "JPN";
    ITerminalCountry["KAZAKHSTAN_KAZ"] = "KAZ";
    ITerminalCountry["KENYA_KEN"] = "KEN";
    ITerminalCountry["KYRGYZSTAN_KGZ"] = "KGZ";
    ITerminalCountry["CAMBODIA_KHM"] = "KHM";
    ITerminalCountry["KIRIBATI_KIR"] = "KIR";
    ITerminalCountry["SAINT_KITTS_AND_NEVIS_KNA"] = "KNA";
    ITerminalCountry["KOREA_REPUBLIC_OF_KOR"] = "KOR";
    ITerminalCountry["KUWAIT_KWT"] = "KWT";
    ITerminalCountry["LAO_PEOPLES_DEMOCRATIC_REPUBLIC_LAO"] = "LAO";
    ITerminalCountry["LEBANON_LBN"] = "LBN";
    ITerminalCountry["LIBERIA_LBR"] = "LBR";
    ITerminalCountry["LIBYA_LBY"] = "LBY";
    ITerminalCountry["SAINT_LUCIA_LCA"] = "LCA";
    ITerminalCountry["LIECHTENSTEIN_LIE"] = "LIE";
    ITerminalCountry["SRI_LANKA_LKA"] = "LKA";
    ITerminalCountry["LESOTHO_LSO"] = "LSO";
    ITerminalCountry["LITHUANIA_LTU"] = "LTU";
    ITerminalCountry["LUXEMBOURG_LUX"] = "LUX";
    ITerminalCountry["LATVIA_LVA"] = "LVA";
    ITerminalCountry["MACAO_MAC"] = "MAC";
    ITerminalCountry["SAINT_MARTIN_FRENCH_PART_MAF"] = "MAF";
    ITerminalCountry["MOROCCO_MAR"] = "MAR";
    ITerminalCountry["MONACO_MCO"] = "MCO";
    ITerminalCountry["MOLDOVA_REPUBLIC_OF_MDA"] = "MDA";
    ITerminalCountry["MADAGASCAR_MDG"] = "MDG";
    ITerminalCountry["MALDIVES_MDV"] = "MDV";
    ITerminalCountry["MEXICO_MEX"] = "MEX";
    ITerminalCountry["MARSHALL_ISLANDS_MHL"] = "MHL";
    ITerminalCountry["MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF_MKD"] = "MKD";
    ITerminalCountry["MALI_MLI"] = "MLI";
    ITerminalCountry["MALTA_MLT"] = "MLT";
    ITerminalCountry["MYANMAR_MMR"] = "MMR";
    ITerminalCountry["MONTENEGRO_MNE"] = "MNE";
    ITerminalCountry["MONGOLIA_MNG"] = "MNG";
    ITerminalCountry["NORTHERN_MARIANA_ISLANDS_MNP"] = "MNP";
    ITerminalCountry["MOZAMBIQUE_MOZ"] = "MOZ";
    ITerminalCountry["MAURITANIA_MRT"] = "MRT";
    ITerminalCountry["MONTSERRAT_MSR"] = "MSR";
    ITerminalCountry["MARTINIQUE_MTQ"] = "MTQ";
    ITerminalCountry["MAURITIUS_MUS"] = "MUS";
    ITerminalCountry["MALAWI_MWI"] = "MWI";
    ITerminalCountry["MALAYSIA_MYS"] = "MYS";
    ITerminalCountry["MAYOTTE_MYT"] = "MYT";
    ITerminalCountry["NAMIBIA_NAM"] = "NAM";
    ITerminalCountry["NEW_CALEDONIA_NCL"] = "NCL";
    ITerminalCountry["NIGER_NER"] = "NER";
    ITerminalCountry["NORFOLK_ISLAND_NFK"] = "NFK";
    ITerminalCountry["NIGERIA_NGA"] = "NGA";
    ITerminalCountry["NICARAGUA_NIC"] = "NIC";
    ITerminalCountry["NIUE_NIU"] = "NIU";
    ITerminalCountry["NETHERLANDS_NLD"] = "NLD";
    ITerminalCountry["NORWAY_NOR"] = "NOR";
    ITerminalCountry["NEPAL_NPL"] = "NPL";
    ITerminalCountry["NAURU_NRU"] = "NRU";
    ITerminalCountry["NEW_ZEALAND_NZL"] = "NZL";
    ITerminalCountry["OMAN_OMN"] = "OMN";
    ITerminalCountry["PAKISTAN_PAK"] = "PAK";
    ITerminalCountry["PANAMA_PAN"] = "PAN";
    ITerminalCountry["PITCAIRN_PCN"] = "PCN";
    ITerminalCountry["PERU_PER"] = "PER";
    ITerminalCountry["PHILIPPINES_PHL"] = "PHL";
    ITerminalCountry["PALAU_PLW"] = "PLW";
    ITerminalCountry["PAPUA_NEW_GUINEA_PNG"] = "PNG";
    ITerminalCountry["POLAND_POL"] = "POL";
    ITerminalCountry["PUERTO_RICO_PRI"] = "PRI";
    ITerminalCountry["KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF_PRK"] = "PRK";
    ITerminalCountry["PORTUGAL_PRT"] = "PRT";
    ITerminalCountry["PARAGUAY_PRY"] = "PRY";
    ITerminalCountry["PALESTINE_STATE_OF_PSE"] = "PSE";
    ITerminalCountry["FRENCH_POLYNESIA_PYF"] = "PYF";
    ITerminalCountry["QATAR_QAT"] = "QAT";
    ITerminalCountry["RUNION_REU"] = "REU";
    ITerminalCountry["ROMANIA_ROU"] = "ROU";
    ITerminalCountry["RUSSIAN_FEDERATION_RUS"] = "RUS";
    ITerminalCountry["RWANDA_RWA"] = "RWA";
    ITerminalCountry["SAUDI_ARABIA_SAU"] = "SAU";
    ITerminalCountry["SUDAN_SDN"] = "SDN";
    ITerminalCountry["SENEGAL_SEN"] = "SEN";
    ITerminalCountry["SINGAPORE_SGP"] = "SGP";
    ITerminalCountry["SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS_SGS"] = "SGS";
    ITerminalCountry["SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA_SHN"] = "SHN";
    ITerminalCountry["SVALBARD_AND_JAN_MAYEN_SJM"] = "SJM";
    ITerminalCountry["SOLOMON_ISLANDS_SLB"] = "SLB";
    ITerminalCountry["SIERRA_LEONE_SLE"] = "SLE";
    ITerminalCountry["EL_SALVADOR_SLV"] = "SLV";
    ITerminalCountry["SAN_MARINO_SMR"] = "SMR";
    ITerminalCountry["SOMALIA_SOM"] = "SOM";
    ITerminalCountry["SAINT_PIERRE_AND_MIQUELON_SPM"] = "SPM";
    ITerminalCountry["SERBIA_SRB"] = "SRB";
    ITerminalCountry["SOUTH_SUDAN_SSD"] = "SSD";
    ITerminalCountry["SAO_TOME_AND_PRINCIPE_STP"] = "STP";
    ITerminalCountry["SURINAME_SUR"] = "SUR";
    ITerminalCountry["SLOVAKIA_SVK"] = "SVK";
    ITerminalCountry["SLOVENIA_SVN"] = "SVN";
    ITerminalCountry["SWEDEN_SWE"] = "SWE";
    ITerminalCountry["SWAZILAND_SWZ"] = "SWZ";
    ITerminalCountry["SINT_MAARTEN_DUTCH_PART_SXM"] = "SXM";
    ITerminalCountry["SEYCHELLES_SYC"] = "SYC";
    ITerminalCountry["SYRIAN_ARAB_REPUBLIC_SYR"] = "SYR";
    ITerminalCountry["TURKS_AND_CAICOS_ISLANDS_TCA"] = "TCA";
    ITerminalCountry["CHAD_TCD"] = "TCD";
    ITerminalCountry["TOGO_TGO"] = "TGO";
    ITerminalCountry["THAILAND_THA"] = "THA";
    ITerminalCountry["TAJIKISTAN_TJK"] = "TJK";
    ITerminalCountry["TOKELAU_TKL"] = "TKL";
    ITerminalCountry["TURKMENISTAN_TKM"] = "TKM";
    ITerminalCountry["TIMORLESTE_TLS"] = "TLS";
    ITerminalCountry["TONGA_TON"] = "TON";
    ITerminalCountry["TRINIDAD_AND_TOBAGO_TTO"] = "TTO";
    ITerminalCountry["TUNISIA_TUN"] = "TUN";
    ITerminalCountry["TURKEY_TUR"] = "TUR";
    ITerminalCountry["TUVALU_TUV"] = "TUV";
    ITerminalCountry["TAIWAN_PROVINCE_OF_CHINA_TWN"] = "TWN";
    ITerminalCountry["TANZANIA_UNITED_REPUBLIC_OF_TZA"] = "TZA";
    ITerminalCountry["UGANDA_UGA"] = "UGA";
    ITerminalCountry["UKRAINE_UKR"] = "UKR";
    ITerminalCountry["UNITED_STATES_MINOR_OUTLYING_ISLANDS_UMI"] = "UMI";
    ITerminalCountry["URUGUAY_URY"] = "URY";
    ITerminalCountry["UNITED_STATES_USA"] = "USA";
    ITerminalCountry["UZBEKISTAN_UZB"] = "UZB";
    ITerminalCountry["HOLY_SEE_VATICAN_CITY_STATE_VAT"] = "VAT";
    ITerminalCountry["SAINT_VINCENT_AND_THE_GRENADINES_VCT"] = "VCT";
    ITerminalCountry["VENEZUELA_BOLIVARIAN_REPUBLIC_OF_VEN"] = "VEN";
    ITerminalCountry["VIRGIN_ISLANDS_BRITISH_VGB"] = "VGB";
    ITerminalCountry["VIRGIN_ISLANDS_U_VIR"] = "VIR";
    ITerminalCountry["VIET_NAM_VNM"] = "VNM";
    ITerminalCountry["VANUATU_VUT"] = "VUT";
    ITerminalCountry["WALLIS_AND_FUTUNA_WLF"] = "WLF";
    ITerminalCountry["SAMOA_WSM"] = "WSM";
    ITerminalCountry["YEMEN_YEM"] = "YEM";
    ITerminalCountry["SOUTH_AFRICA_ZAF"] = "ZAF";
    ITerminalCountry["ZAMBIA_ZMB"] = "ZMB";
    ITerminalCountry["ZIMBABWE_ZWE"] = "ZWE";
})(ITerminalCountry = exports.ITerminalCountry || (exports.ITerminalCountry = {}));
var ITerminalTimezone;
(function (ITerminalTimezone) {
    ITerminalTimezone["EASTERN_STANDARD_TIME_EST"] = "est";
    ITerminalTimezone["CENTRAL_STANDARD_TIME_CST"] = "cst";
    ITerminalTimezone["PACIFIC_STANDARD_TIME_PST"] = "pst";
    ITerminalTimezone["MOUNTAIN_STANDARD_TIME_MST"] = "mst";
    ITerminalTimezone["ALASKA_STANDARD_TIME_AKST"] = "akst";
    ITerminalTimezone["HAWAII_STANDARD_TIME_HST"] = "hst";
    ITerminalTimezone["SINGAPORE_STANDARD_TIME_SST"] = "sst";
    ITerminalTimezone["CHAMORRO_STANDARD_TIME_CHST"] = "chst";
    ITerminalTimezone["ATLANTIC_STANDARD_TIME_AST"] = "ast";
    ITerminalTimezone["_PWT"] = "pwt";
    ITerminalTimezone["_MHT"] = "mht";
    ITerminalTimezone["_CHUT"] = "chut";
    ITerminalTimezone["_NST"] = "nst";
})(ITerminalTimezone = exports.ITerminalTimezone || (exports.ITerminalTimezone = {}));
var ITerminalStatus;
(function (ITerminalStatus) {
    ITerminalStatus[ITerminalStatus["INACTIVE_0"] = 0] = "INACTIVE_0";
    ITerminalStatus[ITerminalStatus["ACTIVE_1"] = 1] = "ACTIVE_1";
})(ITerminalStatus = exports.ITerminalStatus || (exports.ITerminalStatus = {}));
